import { MessageContextValue } from 'stream-chat-react'

export type MessageProps = Partial<MessageContextValue> & {
  lastGroupMessage?: boolean
  firstGroupMessage?: boolean
}

export enum MessageStatusTypes {
  RECEIVED = 'received',
  SENDING = 'sending',
  FAILED = 'failed'
}

